// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-skill-modal-container[data-v-b0420240]{display:flex;flex-direction:column;grid-gap:1rem;gap:1rem}.add-skill-modal-text[data-v-b0420240]{padding-top:1rem}.add-skill-modal-footer[data-v-b0420240]{border-top:5px solid #f5f5f5}.skills-to-add[data-v-b0420240]{display:flex;grid-gap:.5rem;gap:.5rem;flex-wrap:wrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
